module.exports = __webpack_public_path__ + "static/media/Spring Reverb HD VR.3b30102.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/hd-racks/Spring Reverb HD VR.mp3
// module id = eeVl
// module chunks = 12